export default function About() {
  return (
    <section id="about" className="bg-[#F8F6F3] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Left Content */}
          <div className="lg:w-3/5">
            <div className="inline-block bg-[#E8F4F8] px-4 py-2 rounded-full mb-8">
              <span className="text-[#1B2838] text-sm font-semibold uppercase tracking-wide">
                About Good Pitch Roofing
              </span>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-[#1B2838] mb-8 leading-tight">
              Oklahoma Roofing Experts Since 2015
            </h2>

            <div className="space-y-6 mb-10">
              <p className="text-lg text-gray-700 leading-relaxed">
                At Good Pitch Roofing, we specialize in working directly with insurance companies to make your roof repair or replacement completely stress-free. Our team of licensed professionals understands Oklahoma weather and the unique challenges it brings to your home.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                With years of experience serving the Oklahoma City metro area, we're committed to providing top-quality roofing solutions with exceptional customer service. From initial inspection to final installation, we handle every detail so you don't have to.
              </p>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8">
              <div>
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">500+</div>
                <div className="text-gray-600 text-sm font-medium">Roofs Completed</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">A+</div>
                <div className="text-gray-600 text-sm font-medium">BBB Rating</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">24hr</div>
                <div className="text-gray-600 text-sm font-medium">Response Time</div>
              </div>
            </div>
          </div>

          {/* Right Card */}
          <div className="lg:w-2/5">
            <div className="bg-[#2C3E50] rounded-3xl p-10 shadow-2xl">
              <div className="flex items-center justify-between mb-8">
                <span className="text-gray-300 text-sm font-medium">Why Choose Us</span>
                <div className="flex gap-1">
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                </div>
              </div>

              <blockquote className="text-white text-3xl font-medium leading-relaxed mb-12">
                "We handle everything from insurance claims to final inspection, making roof replacement stress-free for Oklahoma homeowners."
              </blockquote>

              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-600 flex items-center justify-center">
                    <i className="ri-user-line text-white text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-white text-lg font-bold">Mike Henderson</div>
                    <div className="text-gray-300 text-sm">Owner & Master Roofer</div>
                  </div>
                </div>
                <button className="w-12 h-12 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}